import { get } from 'lodash';
import { graphql, StaticQuery } from 'gatsby';
import { rgba } from 'polished';
import React from 'react';
import styled from 'styled-components';
import ImageInContext from '../Media/ImageInContext';

const UserFacesSpaced = () => (
  <StaticQuery
    query={graphql`
      query UserFacesSpacedQuery {
        allContentfulFreshStartDiary {
          edges {
            node {
              id
              filerImage {
                altText
                image {
                  file {
                    url
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const stories = get(data, 'allContentfulFreshStartDiary.edges', [])
        .map(s => s.node)
        .filter(s => get(s, 'filerImage.image.file.url') != null).slice(0, 9);
      return (
        <UserFacesSpacedWrapper>
          <div className="space-wrap">
            {Array.prototype.map.call(stories, (story, index) => (
              <div className={`filer-${index}`}>
                <ImageInContext
                  key={index}
                  className={`filer-${index}`}
                  alt={`${story.filerImage.altText} ${index + 1}`}
                  src={get(story, 'filerImage.image.file.url')}
                />
              </div>
            ))}
          </div>
        </UserFacesSpacedWrapper>
      );
    }}
  />
);

const UserFacesSpacedWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
  @media(max-width: 45em) {
    top: 50px;
  }

  div.space-wrap {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: relative;
    @media(max-width: 45em) {
      width: 100%;
      height: 540px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: auto;
    }
  }

  div.space-wrap > div {
    position: absolute;
    border-style: none;
    max-width: 100%;
    border-radius: 50%;
    overflow: hidden;
    background: ${props => rgba(props.theme.colors.brand['700'], 0.9)};
    opacity: 0.5;
    img {
      width: 100%;
      height: 100%;
      mix-blend-mode: luminosity;
      object-fit: cover;
    }
    small {
    }
    @media(max-width: 45em) {
      position: initial;
      border-radius: 0;
      width: 100%;
      height: auto;
      opacity: 0.1;
      small {
        display: none;
      }
    }
  }

  div.filer-0 {
    top: 70px;
    left: -5px;
    width: 110px;
    height: 110px;
  }
  div.filer-1 {
    top: 90px;
    right: -5px;
    width: 89px;
    height: 89px;
  }
  div.filer-2 {
    top: 172px;
    left: -5px;
    width: 125px;
    height: 125px;
  }
  div.filer-3 {
    top: 230px;
    right: 5px;
    width: 120px;
    height: 120px;
  }
  div.filer-4 {
    top: 370px;
    left: 15px;
    width: 119px;
    height: 119px;
  }
  div.filer-5 {
    top: 380px;
    right: 12px;
    width: 106px;
    height: 106px;
  }
  div.filer-6 {
    top: 560px;
    left: 10px;
    width: 93px;
    height: 93px;
  }
  div.filer-7 {
    top: 600px;
    right: 10px;
    width: 86px;
    height: 86px;
  }
  div.filer-8 {
    top: 740px;
    left: 10px;
    width: 70px;
    height: 70px;
    @media(min-width: 45em) {
      display: none;
    }
  }
`;

export default UserFacesSpaced;
